// extracted by mini-css-extract-plugin
export default {"SpinnerPage":"SpinnerPage_SpinnerPage__kaT7O"};